import React from 'react'
import {Navigate, Outlet, Route} from 'react-router'
import {useGate} from 'statsig-react'

import PageNotFound from '@product-web/routes/page-not-found/page-not-found'
import {Page} from '@product-web-features/ui-page'

const MyTeams = React.lazy(async () => import('./screens/my-teams/my-teams'))
const AllTeams = React.lazy(async () => import('./screens/all-teams/all-teams'))
const CreateTeam = React.lazy(async () => import('./screens/create-team/create-team'))

const Wrapper = () => {
    const {value: isPartnerTeamsEnabled} = useGate('partner_teams')

    if (!isPartnerTeamsEnabled) {
        return <PageNotFound />
    }

    return (
        <Page layout="wide" showNav>
            <Outlet />
        </Page>
    )
}

export const routes = (
    <Route element={<Wrapper />}>
        <Route index element={<Navigate to="my-teams" replace />} />
        <Route path="my-teams" element={<MyTeams />} />
        <Route path="all-teams" handle={{allowedRoles: ['partner-owner']}} element={<AllTeams />} />
        <Route path="create" handle={{allowedRoles: ['partner-owner']}} element={<CreateTeam />} />
    </Route>
)
